var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"background_item"}},[_c('canvas',{attrs:{"id":"background_canvas"}})])
}]

export { render, staticRenderFns }